const apiUrl = process.env.NEXT_PUBLIC_API_URL;

export const fetchData = async (endpoint, setState, setLoading, setError) => {
  try {
    if (setLoading) setLoading(true);

    const response = await fetch(`${apiUrl}${endpoint}`, {
      method: "GET",
      credentials: "include", // send & accept cookies
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    setState(data);
  } catch (error) {
    console.error("API Fetch Error:", error);
    if (setError) setError(error.message);
    setState([]);
  } finally {
    if (setLoading) setLoading(false);
  }
};

export const postData = async (endpoint, payload) => {
  const url = `${apiUrl}${endpoint}`;

  try {
    let response;

    if (payload instanceof FormData) {
      response = await fetch(url, {
        method: "POST",
        body: payload, // browser sets headers
        credentials: "include", // include cookies
      });
    } else {
      response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
        credentials: "include", // include cookies
      });
    }

    const json = await response.json();

    if (!response.ok) {
      return {
        success: false,
        message: json.message || "An error occurred.",
      };
    }

    return json;
  } catch (error) {
    console.error("API Post Error:", error);
    return {
      success: false,
      message: error.message || "Unexpected error occurred.",
    };
  }
};

export const deleteData = async (endpoint) => {
  try {
    const response = await fetch(`${apiUrl}${endpoint}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include", // include cookies
    });

    if (!response.ok) {
      const errorResponse = await response.json();
      throw new Error(
        errorResponse.message ||
          `Error: ${response.status} ${response.statusText}`
      );
    }

    return await response.json();
  } catch (error) {
    console.error("API Delete Error:", error);
    throw error;
  }
};
